export default {
  app: {
    notFound: {
      title: 'Siden blev ikke fundet.',
      subtitle: 'Det ser ud til, at du gik vild.',
      text: 'Bare rolig, vi hjælper dig med at navigere herfra',
    },
  },
};
